// tslint:disable
/* MACLE TypeScript 31/07/2026 23:43:12 */
import { PKVitrine, DataVitrine, ConsVitrineAndItem } from '../vo/liquidacaoparcelaejb.vo';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { BaseService, AjaxService, IModelServiceResponse, Parser, ArrayList } from 'maf-web';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class VitrineModelService extends BaseService {
  private _url = 'vitrineService?action=';

  constructor(router: Router, ajax: AjaxService, private toastrService: ToastrService) {
    super(router, ajax, toastrService);
  }

  public exists(pk: PKVitrine): Promise<boolean> {
    let params = {
      "pk": pk
    };
    return this.ajax.post(this._url + 'exists', params)
      .then((r: IModelServiceResponse<boolean>) => r.value)
      .catch((error: any) => this.handleError(error));
  }

  public getData(pk: PKVitrine): Promise<DataVitrine> {
    let params = {
      "pk": pk
    };
    return this.ajax.post(this._url + 'getData', params)
      .then((r: IModelServiceResponse<DataVitrine>) => Parser.jsonToClass(r.value, DataVitrine))
      .catch((error: any) => this.handleError(error));
  }

  public getListVitrineAndItem(): Promise<ConsVitrineAndItem[]> {
    return this.ajax.get(this._url + 'getListVitrineAndItem')
      .then((r: IModelServiceResponse<ArrayList<ConsVitrineAndItem>>) => Parser.jsonToClass(r.value, ConsVitrineAndItem))
      .catch((error: any) => this.handleError(error));
  }

}


